<template>
  <v-menu
    v-model="is_active"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="280px"
    min-width="280px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-if="!is_btn"
        v-model="valid_value"
        outlined
        :label="label"
        prepend-inner-icon="mdi-calendar"
        readonly
        clearable
        v-on="on"
        :error="error"
        :error-messages="errorMessages"
      ></v-text-field>
      <v-btn
        rounded
        small
        v-else
        :outlined="!valid_value"
        color="primary"
        class="mr-2 mb-2"
        v-on="on"
      >
        <span>{{valid_value || label}}</span>
      </v-btn>
    </template>
    <v-date-picker :min="min_date" v-model="valid_value" :locale="locale"></v-date-picker>
  </v-menu>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapState } from "vuex";

export default {
  props: ["label", "value", "error", "error-messages", "always_show", "is_btn"],

  data: () => ({
    is_active: false,
  }),

  computed: {
    ...mapState("locale", {
      locale: "locale",
    }),
    valid_value: {
      get: function () {
        if (this.$props.value !== undefined && this.$props.value != null) {
          return moment(this.$props.value).format("YYYY-MM-DD");
        }
        return null;
      },
      set: function (value) {
        console.log(value);

        if (!value) {
          this.$emit("input", null);
        } else {
          this.$emit("input", moment(value).format("YYYY-MM-DD"));
        }
        this.is_active = false;
      },
    },

    min_date: function () {
      return moment().format("YYYY-MM-DD");
    },
  },
};
</script>